import { useEffect } from "react";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import TextField from "../../../../../UI/GeneralPurpose/SimpleTextField";

const UIText = {
  "es-CL": { label: "Para", placeholder: "mail@dominio.cl" },
  "en-US": { label: "To", placeholder: "mail@domain.cl" },
};

export const ToId = "mail-to";
const id = ToId;

const To = () => {
  const { dispatch, UI } = useUIBp();
  const filter = UI.filter ?? "";

  useEffect(() => {
    const toMatch = filter.match(/to:\(([^)]+)\)/);
    const toValue = toMatch ? toMatch[1] : "";

    if (toValue) {
      dispatch(UIactions.setField({ id, value: toValue }));
    }
  }, [dispatch, filter]);

  return <TextField clearOnUnmount {...{ id: "mail-to", UIText, size: 12 }} />;
};

export default To;
